<template>
  <div>
    <div v-if="pdfUrl" class="pdf-container">
      <iframe 
        ref="pdfIframe" 
        :src="pdfUrl" 
        style="width: 100%; height: 600px; border: 1px solid #ccc;" 
        frameborder="0"
      ></iframe>
    </div>
  </div>
</template>

<script>

import MainLedgerService from '@/services/MainLedgerService'
export default {
  name: 'PdfViewer',
  props: ['fullpath'],
  data() {
    return {
      pdfUrl: null, // Stores the URL.createObjectURL() result
      
      // *** IMPORTANT: This is the sample data. Replace with your actual byte array. ***
      // This is a simple, fake byte array. You will replace this with the 
      // actual ArrayBuffer/Uint8Array you receive from your server/source.
      sampleByteArray: new Uint8Array([
        // These are placeholder bytes. A real PDF file starts with %PDF-
        73, 78, 86, 65, 76, 73, 68, 32, 80, 68, 70, 32, 66, 89, 84, 69, 83
      ]),
    };
  },
  async mounted () {
    try {
        await this.loadAndShowPdf()
      } catch(err) {
      // eslint-disable-next-line
      console.log(err)
    }   
  },
  
  methods: {
    /**
     * Simulates fetching data and creates the Blob URL.
     */
    async loadAndShowPdf() {
      console.log('Imam this.fullpath', this.fullpath)
      if (this.fullpath) {
          const showFile ={
            showFile: this.fullpath
          }
        // 1. Ensure any previous object URL is revoked to free memory
        this.revokeCurrentUrl();

        await MainLedgerService.showPdf(showFile)
          .then(res => {
            const data = res.data
    
            var byteCharacters = atob(data);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "application/pdf" });
            this.pdfUrl = URL.createObjectURL(blob);

            //FileSaver.saveAs(blob, "invoice.pdf")

            // // const zoveSe = this.mainledger.MLFree2 ? this.mainledger.MLFree2 : 'Book'
            //const header = res.headers
            //const fileType = header['content-type']
            //const file = new Blob([data], {type: fileType})
            // eslint-disable-next-line
            //console.log(' have file ', blob)
            

            // -->> const fileurl = window.URL.createObjectURL(blob)
            // -->window.open(fileurl)

            //FileSaver.saveAs(file, 'invoice.pdf');
          }).catch(error => {
            this.text = 'Error ' + error
            this.color = 'red'
            this.snackbar = true
          })
      } else {
        alert(this.lang.CannotFind)
      }          
  
    },

    /**
     * Revokes the object URL to release the memory it holds.
     * This is a crucial cleanup step!
     */
    revokeCurrentUrl() {
      if (this.pdfUrl) {
        URL.revokeObjectURL(this.pdfUrl);
        console.log('Previous PDF Object URL revoked.');
        // Optionally set pdfUrl to null if you want to clear the iframe content
        // this.pdfUrl = null; 
      }
    }
  },
  
  /**
   * Vue 2 lifecycle hook: Clean up when the component is destroyed.
   */
  beforeDestroy() {
    // IMPORTANT: Call the cleanup function when the component is unmounted!
    this.revokeCurrentUrl();
  }
};
</script>